<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="center" id="dedication" style="margin-top:50px;">This is for Robin Walz, Professor of History at the University of Alaska Southeast, to our mutual interest in this remarkable period of history and to our delight in its many ramifications.</p>
<p class="noind" style="margin-top:30px;">Tapestry: History’s woven moment being spun and dyed, is linked pattern to pattern to design and panorama, hiding truth until unravelled.</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-dedication.vue?bcdd914a